import React from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

import {
    useIsGeoCheckFailure,
    useIsGeoCheckInProgress,
} from '~SpectateStore/hooks/userHooks';

import './styles.scss';

const GeoLocationCheck = () => {
    const [ t ] = useTranslation();
    const isGeoCheckFailure = useIsGeoCheckFailure();
    const isGeoCheckInProgress = useIsGeoCheckInProgress();

    // It should never happen because the component is rendered
    // when Geo Check is in progress or it failed.
    if (!isGeoCheckInProgress && !isGeoCheckFailure) {
        return null;
    }

    const inProgress = () => {
        return <>
            <div className="betslip__geo-check-primary-text">
                {t('betslip.please_wait')}
            </div>
            <span className="betslip__geo-check-secondary-text">
                {t('betslip.geo_check_in_progress')}
            </span>
        </>;
    };

    const failed = () => {
        return <>
            <span className="betslip__geo-check-icon"></span>
            <span className="betslip__geo-check-primary-text">
                {t('betslip.geo_check_failure')}
            </span>
        </>;
    };

    const classes = classNames([
        'betslip__geo-check',
        isGeoCheckInProgress && 'betslip__geo-check--inProgress',
        isGeoCheckFailure && 'betslip__geo-check--failed',
    ]);

    return (
        <div className={classes}>
            {isGeoCheckInProgress && inProgress()}
            {isGeoCheckFailure && failed()}
        </div>
    );
};

export default GeoLocationCheck;
